<template>
  <section class="cc-wizard-panel" :class="{ 'cc-wizard-panel--expanded': expanded }">
    <header class="cc-wizard-panel__header">
      <span v-if="icon" class="cc-wizard-panel__icon">
        <i :class="icon" aria-hidden="true" />
      </span>
      <h3 class="cc-wizard-panel__title">{{ title }}</h3>
    </header>
    <div class="cc-wizard-panel__body">
      <slot />
    </div>
    <div v-if="expanded && $slots.expanded" class="cc-wizard-panel__expanded">
      <slot name="expanded" />
    </div>
  </section>
</template>

<script>
export default {
  name: 'CreateCompanyWizardPanel',
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: '',
    },
    expanded: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
